import {ChangeDetectorRef, Component, Inject, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DetailPopup} from '../../../mapping-classes/detail-popup';
import {DetailPopupRequestModel} from '../../../services/popup/detail-popup-request.model';
import * as DetailTable from '../../../table-lib';
import {DomService} from '../../../../../../services/dom-service/dom.service';
import {PopupContinentsComponent} from '../../../detail-table/debit-card/popup-continents-table/popup-continents-table.component';

@Component({
  selector: 'app-detail-table',
  templateUrl: './debitcard-popup.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})

export class DebitCardPopupComponent implements DetailPopup {
  @ViewChild('table', {read: ViewContainerRef}) tableContainer: ViewContainerRef;
  @ViewChild('link_id_table', {read: ViewContainerRef}) linkIdTableContainer: ViewContainerRef;

  title: string;
  restrictedData: boolean;
  errorText: string;
  hasData = true;
  data;
  tableInstance;
  tableComponent;
  expanded = false;
  emptyValuePlaceholder = '-';

  constructor(private domService: DomService, private changeRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<DebitCardPopupComponent>,
              @Inject(MAT_DIALOG_DATA) public inputData: any) {
    this.title = 'Werelddelen' + DetailPopupRequestModel.tableNumber;

    if (inputData.listOfError && inputData.listOfError.length !== 0) {
      this.createErrorMessage(inputData);
      this.hasData = false;
    } else if (inputData && inputData.detailsViewObject) {
      this.data = inputData;
      this.restrictedData = inputData.detailsViewObject['restrictedData'];
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    this.addValues(this.data);
    this.changeRef.detectChanges();
  }

  onClick() {
    this.expanded = !this.expanded;
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.title = 'Debetrente afspraken';
        this.errorText = 'Debetrente afspraken niet gevonden.';
      }
    }
  }

  addValues(response) {
    const detailsViewObject = response.detailsViewObject;
    this.createTable(detailsViewObject);
  }

  private createTable(detailsViewObject) {
    this.tableInstance = new DetailTable['Continents'](detailsViewObject);
    if (!this.tableContainer) {
      return null;
    }
    this.tableComponent = this.createDebitCardTable();
  }

  private createDebitCardTable() {
    const viewRef = this.domService.addComponentToDOM(PopupContinentsComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as PopupContinentsComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private setBasicComponentValues(componentToReturn) {
    componentToReturn.errorText = this.tableInstance.errorText;
    componentToReturn.showTable = (componentToReturn.errorText === null || componentToReturn.errorText === undefined);
    componentToReturn.restrictedData = this.restrictedData;
    componentToReturn.tableColumns = this.tableInstance.rowHeaders;
    componentToReturn.tableData = this.tableInstance.rowData;
    return componentToReturn;
  }
}
